import React, { useState, useEffect } from 'react'
import { useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';
import { AiFillEye } from "react-icons/ai";

function Edituser(){ 
    const apiUrl = API_URL;
    const [items, setItems] = useState("");
    const [successMessages, setSuccessMessages] = useState([]);
    const [inputType, setInputType] = useState('password');
    const user_Id = useParams();
    const getuserId = user_Id.userid;

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                user_id: getuserId
            };
            const res = await fetch(`${apiUrl}/admin/incompleteuserdetails`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);

    const clicktoupdateadmin = async (e) => {
        e.preventDefault();
        const admindata = new FormData(e.target);
        const firstname = admindata.get('firstname')
        const lastname = admindata.get('lastname')
        const email = admindata.get('email')
        const password = admindata.get('password')
        const postData = {
            userId:getuserId,
            firstname:firstname,
            lastname:lastname,
            email:email,
            password:password
        };
        const result = await fetch(`${apiUrl}/admin/updateusers`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status == 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status == 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
    }

    const passShow = ()=>{
        setInputType(inputType === 'password' ? 'text': 'password')
    }

    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }

    return (
        <div className='width90'>
            <h2 className='pageTitle'>Update User details</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={clicktoupdateadmin}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="firstname">First Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="firstname" name="firstname" defaultValue={items.name} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="lastname">Last Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="lastname" name="lastname" defaultValue={items.lastname} />
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="email">Email:</label>
                        <div className="col-sm-4">
                            <input type="email" className="form-control" id="email" name="email" defaultValue={items.email} />
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Password:</label>
                        <div className="col-sm-4  mt-1 position-relative">
                            <input type={inputType} className="form-control" name="password" id="password" />
                            <AiFillEye className='hide_show' onClick={passShow}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Edituser;